// returnTo is the origin (path + search + hash) of whoever linked to a shared
// root page, so the origin's own URL state (record, filter) is exactly what
// Back restores. It arrives from the address bar, so it is untrusted: only a
// plain in-app path to a known area is honoured. Anything else yields null
// and the caller shows no Back affordance — we never redirect to a guess.
const ALLOWED_PREFIXES = [
    '/capture',
    '/rfi-response',
    '/opportunities',
    '/tracking-profiles',
    '/delivery',
    '/library',
    '/registries'
];
const MAX_DECODE_PASSES = 3;
// Backslashes (browsers treat `/\host` as `//host`) and control characters
// (browsers strip tab/newline, turning `/<TAB>/host` into `//host`).
// biome-ignore lint/suspicious/noControlCharactersInRegex: control characters are exactly what is rejected here
const UNSAFE_CHARS = /[\\\u0000-\u001f\u007f]/;
const isSingleSlashPath = (s)=>s.startsWith('/') && !s.startsWith('//');
export function safeReturnTo(raw) {
    if (!raw) return null;
    // Check every decoded layer, so `/%2F/host`, `/%5Chost` and double-encoded
    // variants are caught as the browser or a downstream decoder would see them.
    let layer = raw;
    for(let pass = 0;; pass++){
        if (UNSAFE_CHARS.test(layer) || !isSingleSlashPath(layer)) return null;
        let next;
        try {
            next = decodeURIComponent(layer);
        } catch  {
            return null;
        }
        if (next === layer) break;
        if (pass >= MAX_DECODE_PASSES) return null;
        layer = next;
    }
    const pathname = raw.split(/[?#]/, 1)[0];
    if (pathname.split('/').includes('..')) return null;
    const allowed = ALLOWED_PREFIXES.some((p)=>pathname === p || pathname.startsWith(`${p}/`));
    return allowed ? raw : null;
}
